import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@astro/auth'
import { ConsultationInviteWatcher, SocketProvider } from '@astro/socket'

// One QueryClient per app. Server-cache config lives here; client state in @astro/store.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false },
  },
})

/**
 * Shared provider stack every app in the monorepo mounts at its root:
 *   TanStack Query (server cache) -> Auth (silent SSO) -> Socket (realtime) -> app tree.
 */
export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          {children}
          {/* Seeker may be anywhere in the suite when the astrologer starts the
              video consultation — this pops the invite and hands off to jyotish. */}
          <ConsultationInviteWatcher />
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
